import type { IChatStoreState } from '@/modules/chat-matrix-fast/types/IChat'

export interface ChatCoreThis extends IChatStoreState {
  $state: IChatStoreState
  fetchChats(types?: string, options?: { silent?: boolean }): Promise<void>
  [key: string]: any
}

export function defineChatActions<A>(actions: A & ThisType<ChatCoreThis>): A {
  return actions
}
